import { render, staticRenderFns } from "./estatisticas.vue?vue&type=template&id=58a444b8&scoped=true"
import script from "./estatisticas.vue?vue&type=script&lang=js"
export * from "./estatisticas.vue?vue&type=script&lang=js"
import style0 from "./estatisticas.vue?vue&type=style&index=0&id=58a444b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a444b8",
  null
  
)

export default component.exports